export default __webpack_public_path__ + "static/logo-3af2105fcefc948ecc6d822fbfd7cd15.png";